import React from "react";
import { CalendarDays, Monitor, Building2, ClipboardList } from "lucide-react";

// Presentational lucide icon + tone per counter title (falls back to the image icon)
const COUNTER_LUCIDE = {
  "Total Sessions": { Icon: CalendarDays, tone: "bg-[#EFF6FF] text-[#2563EB]" },
  Virtual: { Icon: Monitor, tone: "bg-[#F0FDFA] text-[#0D9488]" },
  "On-Premise": { Icon: Building2, tone: "bg-[#FFF7ED] text-[#EA580C]" },
  Survey: { Icon: ClipboardList, tone: "bg-[#F5F3FF] text-[#7C3AED]" },
};

export default function CalenderCounter(props) {
  const { icon, title, count } = props;
  const lucide = COUNTER_LUCIDE[title];
  return (
    <div className="flex flex-col w-full h-full bg-white border-[1px] border-solid border-[#E2E8F0] rounded-2xl p-3 shadow-sm hover:shadow-md transition-shadow">
      <div className="flex items-start justify-between mb-1.5">
        <div className={`flex items-center justify-center w-[38px] h-[38px] rounded-xl ${lucide ? lucide.tone : "bg-[#EFF6FF]"}`}>
          {lucide ? (
            <lucide.Icon size={18} />
          ) : (
            <img src={icon} className="w-6 h-6 object-contain" alt={title} />
          )}
        </div>
      </div>
      <div className="text-[26px] leading-tight font-bold text-[#171717] font-poppins mb-0">
        {count}
      </div>
      <p className="mt-0.5 mb-0 text-[13px] uppercase tracking-wide font-medium text-[#64748B] font-poppins">
        {title}
      </p>
    </div>
  );
}
